import React, { Component } from 'react'
import Fade from 'react-reveal/Fade'
import YouTube from 'react-youtube';




export class StatsSection extends Component {

    _onReady(event) {
        // access to player in all event handlers via event.target
        event.target.pauseVideo();
    }

    render() {

        const opts = {
            height: '275',
            width: '475',
            playerVars: { // https://developers.google.com/youtube/player_parameters
                autoplay: 0
            }
        };

        return (
            <section className="content-section-03" id="timeline">
                <div className="shape">
                    {/* <img src={require("../../assets/image/landing-4.svg")} alt="" /> */}
                </div>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-xl-5 col-lg-6 col-md-5 col-sm-6 col-10">
                            <div className="content-img">
                                <Fade left>
                                    <main>
                                        <p><b>Workshop</b> 25 September 2019</p>
                                        <p><b>Registration</b> 25 September - 31 Oktober 2019</p>
                                        <p><b>Screening</b> 1 - 8 November 2019</p>
                                        <p><b>Hackathon  16 - 17 November 2019</b></p>
                                        <p><b>Awarding</b>   26 November 2019</p>
                                    </main>
                                </Fade>
                            </div>
                        </div>
                        <div className="col-xl-5  offset-xl-1 col-lg-6 col-md-7 col-sm-6 ">
                            <div className="content-left-content">
                                <h2>Timeline</h2>
                                <p> 
                                    We want you to engage into our Digital Construction Hack. 
                                    Interested into the schedule of #DCH2019?
                                </p>
                                <div className="content-bottom-part">
                                    <p> Watch the workshop here</p>

                                    <YouTube
                                        videoId="nDYOC8HgsWc"
                                        opts={opts} onReady={this._onReady}/>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
            </section>
        )
    }
}

export default StatsSection
